import { T } from "@/lib/i18n";
import { openCookiePrefs } from "@/components/widgets/CookieConsent";
import { Link } from "react-router-dom";
import { SwissCross } from "@/components/Header";
import { useLang } from "@/context/LangContext";

export const Credits = ({ dark }) => (
  <div data-testid="footer-credits" className={`text-[11px] leading-relaxed ${dark ? "text-[#71717a]" : "text-[#5b6168]"}`}>
    {T("Copyright © GWD - Grafica Web Design ~ 2026 Powered by Pixaweb sagl -")}{" "}
    <a href="mailto:info@graficawebdesign.com" className="hover:text-[#E0262C] underline-offset-2 hover:underline">info@graficawebdesign.com</a> -{" "}
    <a href="https://www.graficawebdesign.com" target="_blank" rel="noreferrer" className="hover:text-[#E0262C] underline-offset-2 hover:underline">www.graficawebdesign.com</a>
  </div>
);

const linkCls = "underline-offset-2 transition-colors hover:text-[#E0262C] hover:underline";
const Sep = () => <span aria-hidden="true" className="hidden md:inline text-[#cfd6d9]">|</span>;

export const LegalBar = () => (
  <div data-testid="footer-legal-bar" className="border-t border-[#cfd6d9] bg-[#f4f6f7]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex flex-col md:flex-row items-center justify-center gap-2 md:gap-3 text-xs text-[#5b6168] text-center">
      <Link to="/termini-e-condizioni" data-testid="footer-terms-link" className={linkCls}>{T("Termini e Condizioni", "Terms and Conditions")}</Link>
      <Sep />
      <Link to="/privacy-policy" data-testid="footer-privacy-link" className={linkCls}>Privacy Policy</Link>
      <Link to="/cookie-policy" data-testid="footer-cookie-link" className={linkCls}>Cookie Policy</Link>
      <Link to="/sicurezza-e-privacy" data-testid="footer-security-link" className={linkCls}>{T("Sicurezza e privacy", "Security and privacy")}</Link>
      <Link to="/guide" data-testid="footer-guide-link" className={linkCls}>{T("Guide", "Guides")}</Link>
      <button type="button" data-testid="footer-cookie-prefs" onClick={openCookiePrefs} className={linkCls}>{T("Preferenze cookie", "Cookie preferences")}</button>
      <Sep />
      <span data-testid="footer-copyright">© {new Date().getFullYear()} PIXAWEB Sagl — Via Cantonale 19, 6900 Lugano (CH)</span>
      <Sep />
      <a href="mailto:legal@pixawebch.com" data-testid="footer-legal-contact" className={linkCls}>{T("Contatti legali", "Legal contacts")}</a>
    </div>
  </div>
);

export const SiteFooter = () => {
  const { tr } = useLang();
  return (
  <footer data-testid="site-footer" className="border-t border-[#cfd6d9] mt-8">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8">
      <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-3 text-xs text-[#5b6168] font-mono text-center md:text-left">
        <div className="flex items-center justify-center md:justify-start gap-3 shrink-0">
          <img src="/brand/aurora-mark.webp" alt="" loading="lazy" width="24" height="24" className="w-6 h-6 rounded-sm" />
          <SwissCross className="w-3 h-3" />
          <span className="whitespace-nowrap">Aurora-ADV · Made in Switzerland</span>
        </div>
        <span data-testid="footer-autodeleting" className="leading-relaxed"><span className="hidden md:inline">· </span>{tr("Proteggiamo i tuoi dati con cifratura TLS oggi e AES-256 sui dati salvati in arrivo, lavoriamo con la precisione svizzera, spingiamo il marketing con Aurora®", "We protect your data with TLS encryption today and AES-256 for stored data coming soon, work with Swiss precision, and boost your marketing with Aurora®")}</span>
      </div>
    </div>
    <div className="border-t border-[#cfd6d9]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex flex-col md:flex-row items-center justify-between gap-2 text-[11px] text-[#5b6168]">
        <div data-testid="footer-company">PIXAWEB Sagl · Via Cantonale 19, 6900 Lugano, {T("Svizzera", "Switzerland")} · UID CHE-364.397.948 ·{" "}
          <a href="mailto:legal@pixawebch.com" className="hover:text-[#E0262C] hover:underline">legal@pixawebch.com</a>
        </div>
      </div>
    </div>
    <LegalBar />
  </footer>
  );
};
